import { apiService } from '../../..'
import { PostConsumerTagsRequest, PutConsumerTagsRequest } from '../types'
import { transformGetConsumerTagsResponse, transformGetConsumerTagsWithDataResponse } from '../utils'

const baseUrl = 'portal/consumers/tags'

export const consumerTagsService = apiService.service.injectEndpoints({
  endpoints: (build) => ({
    getConsumerTags: build.query<ReturnType<typeof transformGetConsumerTagsResponse>, void>({
      query: () => {
        return {
          url: baseUrl,
          method: 'GET',
        }
      },
      transformResponse: transformGetConsumerTagsResponse,
      providesTags: ['ConsumerTags'],
    }),
    getConsumerTagsWithData: build.query<ReturnType<typeof transformGetConsumerTagsWithDataResponse>, void>({
      query: () => {
        return {
          url: `${baseUrl}?includeData=true`,
          method: 'GET',
        }
      },
      transformResponse: transformGetConsumerTagsWithDataResponse,
      providesTags: ['ConsumerTagsWithData'],
    }),
    createConsumerTag: build.mutation<void, PostConsumerTagsRequest>({
      query: (req) => {
        return {
          url: baseUrl,
          method: 'POST',
          data: req.body,
        }
      },
      invalidatesTags: ['ConsumerTags', 'ConsumerTagsWithData'],
    }),
    updateConsumerTag: build.mutation<void, PutConsumerTagsRequest>({
      query: (req) => {
        return {
          url: baseUrl,
          method: 'PUT',
          data: req.body,
        }
      },
      invalidatesTags: ['ConsumerTags', 'ConsumerTagsWithData'],
    }),
  }),
})
